import { IconButton, Tooltip } from '@mui/material';
import { Create as IconCreate } from '@mui/icons-material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import EditIdentityIdentifierDialog from './EditIdentityIdentifierDialog';
import TestIds from 'Tests/TestIds';

interface Props {
  identity: string;
  personIdentifier: string;
  organizationCode: string;
  directoryCode: string;
}

function EditIdentityIdentifierToggle(props: Readonly<Props>) {
  const { identity, personIdentifier, organizationCode, directoryCode } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Tooltip
        title={<FormattedMessage id="common.action.edit" />}
        placement="bottom"
      >
        <IconButton
          onClick={() => setIsDialogOpen(true)}
          data-testid={TestIds.pages.userProfile.directories.editIdentityIdentifierButton}
          size="large">
          <IconCreate />
        </IconButton>
      </Tooltip>
      {isDialogOpen && (
        <EditIdentityIdentifierDialog
          identity={identity}
          personIdentifier={personIdentifier}
          organizationCode={organizationCode}
          directoryCode={directoryCode}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  );
}

export default EditIdentityIdentifierToggle;
